import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont } from '../theme';

export const useUserAddressBookStyles = createStyles(({ token }) => ({
  userAddressBook: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    flexDirection: 'column',

    '> p': {
      fontFamily: token.fontFamily,
      fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
      textAlign: 'center',
      color: ThemeColors.COLOR_GREY3,
      marginBottom: 18,
      lineHeight: '25px',
      width: 315,
    },

    '> .ant-form': {
      width: 315,
    },
  },
}));
